import React from "react";
import classNames from "classnames";
import { DateTime } from "luxon";
import { Props } from "./types";
import { DateTimeInput } from "./dateTimeInput";
import styles from "./styles.scss";

function formatStoredDate(iso: string, zone: string): string {
  const dt = DateTime.fromISO(iso, { zone: "utc" }).setZone(zone);
  return dt.isValid ? dt.toLocaleString(DateTime.DATE_SHORT) : "";
}

function DateForm({
  value,
  projectTimezone,
  readOnly,
  required,
  disabled,
  edit,
  submit,
}: Props) {
  const zone = projectTimezone ?? DateTime.local().zoneName;

  return readOnly ? (
    <div className={classNames(styles.dateForm, styles.readOnly)}>
      <p className={styles.input}>
        {value ? formatStoredDate(value, zone) : ""}
      </p>
    </div>
  ) : (
    <div className={styles.dateForm}>
      <DateTimeInput
        dateTime={value}
        projectTimezone={projectTimezone}
        placeholder="-"
        isDisabled={disabled}
        readOnly={!!readOnly}
        required={!!required}
        input={(dateTime) => !disabled && submit(dateTime)}
      />
    </div>
  );
}

export { DateForm };
